module.exports = __webpack_public_path__ + "media/configurations/SO-SX-SX-SO-98a61242.png";